module.exports = __webpack_public_path__ + "img/psd_des_3.33cc082a.jpg";